import { AlertStyle } from "./AlertStyle";
import { AlertType } from "./AlertType";

/** The base interface for alert errors. */
export interface IAlertError {

  /** The alert ID. */
  readonly id?: string;

  /** The alert type. */
  readonly type: AlertType;

  /** The alert style. */
  readonly style: AlertStyle;

  /** The alert timeout in milliseconds. */
  readonly timeout?: number;

  /** The alert message. */
  readonly message: string;
}

/** An alert error which when thrown in certain contexts will show an alert. */
export class AlertError extends Error implements IAlertError {

  /** The alert ID. */
  public readonly id?: string;

  /** The alert type. */
  public readonly type: AlertType;

  /** The alert style. */
  public readonly style: AlertStyle;

  /** The alert timeout in milliseconds. */
  public readonly timeout?: number;

  /**
   * Initializes a new instance of the AlertError class.
   * @param message The alert message.
   * @param type The alert type.
   * @param style The alert style.
   */
  constructor(message: string, type: AlertType, style: AlertStyle, id?: string, timeout?: number) {
    super(message);

    this.id = id;
    this.type = type;
    this.style = style;
    this.timeout = timeout;
  }
}

/**
 * Indicates whether the supplied error is a valid alert error.
 * @param error The error to test.
 * @returns True if a valid IAlertError, otherwise false.
 */
export function isAlertError(error: unknown): error is IAlertError {
  if (error instanceof AlertError) return true;

  if (error && error instanceof Object && "type" in error && "style" in error && "message" in error)
    return true;

  return false;
}
